import api from './api';

export interface KitComponenteDto {
  codigoArticulo: string;
  descripcion?: string | null;
  cantidad: number;
  notas?: string | null;
  tipoArticulo?: string | null;
  unidadMedida?: string | null;
  costo?: number | null;
}

export interface KitDto {
  codigoArticulo: string;
  descripcion?: string | null;
  codigoReceta: string;
  componentes: KitComponenteDto[];
}

export interface KitStockComponenteDto {
  codigoArticulo: string;
  descripcion?: string | null;
  cantidadPorKit: number;
  stockDisponible: number;
  kitsPosibles: number;
  esLimitante: boolean;
}

export interface KitStockDto {
  codigoArticulo: string;
  disponible: number;
  nroUbicacion?: number | null;
  componentes: KitStockComponenteDto[];
}

const TIPOS_COMPONENTES_KIT = 'MP,RV,VD,PT,SE,SER,KIT';

const kitService = {
  tiposComponentesPermitidos: TIPOS_COMPONENTES_KIT,

  getKit: async (codigoArticulo: string): Promise<KitDto | null> => {
    try {
      const resp = await api.get(`/api/Productos/${encodeURIComponent(codigoArticulo)}/kit`);
      return resp.data as KitDto;
    } catch (error: unknown) {
      const status = (error as { response?: { status?: number } })?.response?.status;
      if (status === 404) return null;
      throw error;
    }
  },

  upsertKit: async (
    codigoArticulo: string,
    componentes: KitComponenteDto[],
  ): Promise<KitDto> => {
    const resp = await api.put(`/api/Productos/${encodeURIComponent(codigoArticulo)}/kit`, {
      componentes,
    });
    return resp.data as KitDto;
  },

  getStockKit: async (
    codigoArticulo: string,
    nroUbicacion?: number | null,
  ): Promise<KitStockDto> => {
    const resp = await api.get(`/api/Productos/${encodeURIComponent(codigoArticulo)}/stock-kit`, {
      params: nroUbicacion != null && nroUbicacion > 0 ? { nroUbicacion } : undefined,
    });
    return resp.data as KitStockDto;
  },
};

export default kitService;
